export default "__VITE_ASSET__Cuj0$Lw2__"